import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import FormLabel from "./FormLabel";
import { withStyles } from "@mui/styles";
import { FontSize } from "src/const/font";
import _ from "lodash";

interface Props<T extends FieldValues> extends Omit<TextFieldProps, "name"> {
  control: Control<T>;
  name: FieldPath<T>;
  styleLabel?: React.CSSProperties;
  onChangeCustom?: (e: any) => void;
}
const CssTextField = withStyles((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      borderRadius: "16px",
      fontSize: FontSize.normal.default,
      [theme.breakpoints.down("md")]: {
        fontSize: FontSize.normal.p4,
      },
      "& .MuiInputBase-input": {
        padding: "14px 8px 14px 20px",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E0",
      },
      "&.Mui-focused fieldset": {
        borderWidth: "1px",
      },
    },
    "& ::before": {
      borderBottomRightRadius: "20px",
    },
  },
}))(TextField);

const numberRegex = /^[0-9\b]+$/;
const ControllerTextField = <T extends FieldValues>(props: Props<T>) => {
  const {
    control,
    name,
    variant,
    title,
    label,
    required,
    styleLabel,
    onChangeCustom,
    type,
    ...rest
  } = props;

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <>
          <FormLabel
            style={styleLabel}
            title={title}
            name={name}
            required={required}
          ></FormLabel>
          <CssTextField
            autoComplete={"off"}
            id={name}
            fullWidth
            variant={variant}
            required={required}
            error={Boolean(error)}
            helperText={error?.message && error.message}
            {...field}
            onChange={(e) => {
              if (type === "number") {
                if (
                  !_.isNaN(Number(e?.target?.value)) ||
                  _.isEmpty(e?.target?.value)
                ) {
                  if (
                    numberRegex?.test(e?.target?.value?.trim()) ||
                    _.isEmpty(e?.target?.value)
                  ) {
                    field.onChange(
                      e?.target?.value?.replace(/ + /g, " ")?.trim() as any
                    );
                  }
                } else {
                  if (_.isNaN(Number(e?.target?.value?.split("")[0]))) {
                    field.onChange("" as any);
                  }
                }
              } else {
                field.onChange(e?.target?.value?.replace(/ + /g, " ") as any);
              }
            }}
            {...rest}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </>
      )}
      name={name}
      control={control}
    />
  );
};

export default ControllerTextField;
